export default "__VITE_ASSET__bQuge326__"